import React, {Fragment, useState, useEffect} from 'react'
import {Accordion, TextArea, Form, Icon} from 'semantic-ui-react'
import * as moment from 'moment'
import * as StoriesActions from '../../../actions/StoriesActions'
import {useDispatch, useSelector} from 'react-redux';

export const Category = (props) => {
    const [active, setActive] = useState(true);

    const dispatch = useDispatch();
    const settings = {
        category: '',
        ...useSelector(({stories}) => stories.selected.settings)
    }

    return (
        <Fragment>
            <Accordion.Title active={active} onClick={(e) => {
                    setActive(!active);
                }}><Icon name='dropdown' /> Kategorie</Accordion.Title>
            <Accordion.Content active={active}>
                <Form>
                    <Form.Field>
                        <input disabled={props.readonly?true:null} value={settings.category} placeholder='Kategorie, z.B. Fußball | Bundesliga' onChange={(e) => {
                            dispatch(StoriesActions.update_settings('category', e.target.value));
                        }} />
                    </Form.Field>
                </Form>
            </Accordion.Content>
        </Fragment>
    )
}